export const formatRuntime = (value: number | null | undefined) => {
    if (value === null || value === undefined) return '';
    return `${value} ${value === 1 ? 'Monat' : 'Monate'}`;
};
